/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Pain_Item11Inputs */

const ja_playdata_eventreport_pain_item11 = /** @type {(inputs: Playdata_Eventreport_Pain_Item11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会の実績を報告したい。しかしデータが手元に無い`)
};

const en_playdata_eventreport_pain_item11 = /** @type {(inputs: Playdata_Eventreport_Pain_Item11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to report on how the event performed, but I have no data to hand`)
};

/**
* | output |
* | --- |
* | "I want to report on how the event performed, but I have no data to hand" |
*
* @param {Playdata_Eventreport_Pain_Item11Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_pain_item11 = /** @type {((inputs?: Playdata_Eventreport_Pain_Item11Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Pain_Item11Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_pain_item11(inputs)
	return en_playdata_eventreport_pain_item11(inputs)
});
export { playdata_eventreport_pain_item11 as "playdata_eventReport_pain_item1" }